import { useEffect, useState } from "react";
import { X, Share, Plus } from "lucide-react";

const DISMISS_KEY = "fh_install_hint_dismissed";

function isIOS() {
  const ua = navigator.userAgent || "";
  const iOSDevice = /iphone|ipad|ipod/i.test(ua);
  const iPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  return iOSDevice || iPadOS;
}

function isStandalone() {
  return (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) || window.navigator.standalone === true;
}

export default function InstallHint() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isIOS() && !isStandalone() && !localStorage.getItem(DISMISS_KEY)) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-x-3 bottom-3 z-[100] fade-up" data-testid="ios-install-hint">
      <div className="mx-auto flex max-w-md items-start gap-3 rounded-[var(--card-radius)] border border-[var(--border-accent)] bg-[var(--bg-surface)]/95 p-4 shadow-2xl backdrop-blur-xl">
        <span className="mt-0.5 flex h-9 w-9 flex-none items-center justify-center rounded-full bg-[var(--accent)]/15 text-[var(--accent-hover)]">
          <Share size={18} />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-[var(--text-primary)]">Add The Dial to your Home Screen</p>
          <p className="mt-1 text-xs leading-relaxed text-[var(--text-secondary)]">
            Tap <Share size={12} className="inline align-[-1px]" /> then <span className="inline-flex items-center gap-0.5 font-semibold text-[var(--text-primary)]"><Plus size={11} className="inline" /> Add to Home Screen</span> for one-tap return after watching.
          </p>
        </div>
        <button onClick={dismiss} className="flex-none rounded-full p-1 text-[var(--text-muted)] hover:text-[var(--text-primary)]" data-testid="ios-install-hint-dismiss" aria-label="Dismiss">
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
